module.exports = __webpack_public_path__ + "img/wm.e4f5a807.png";